import { Incarico } from './incarico';
import { Model } from './model';

export class StatoVideoperizia extends Model {
  static apiUrl: string = "stati_videoperizia";

  nome: string;

  incarichi: Incarico[];


  deserialize(input: any): StatoVideoperizia {
    let retV: StatoVideoperizia = new StatoVideoperizia();
    retV = super.deserialize(input) as StatoVideoperizia;

    if (input?.incarichi) {
      retV.incarichi = input.incarichi.map(m => new Incarico().deserialize(m));
    }

    return retV;
  }

}
